import React, { useState, useRef } from "react";
import "../style/AdminSidebar.css";

const menuItems = [
  { href: "/allcarsa", label: "Autos", icon: "/icons/car.png" },
  { href: "/addcar", label: "Agregar autos", icon: "/icons/sum.png" },
  { href: "/createauction", label: "Subastas", icon: "/icons/store.png" },
  { href: "/allusers", label: "Compradores", icon: "/icons/user.png" },
  { href: "/boletin", label: "Boletines", icon: "/icons/email.png" },
  { href: "/boletin-subastas", label: "Boletín Subastas", icon: "/icons/email.png" },
  { href: "/editcontent", label: "Contenido", icon: "/icons/content.png" },
  { href: "/banner", label: "Banner", icon: "/icons/banner-white.png" },
  { href: "/notificationsadmin", label: "Notificaciones", icon: "/icons/campana.png" },
  { href: "/caradrequests", label: "Anuncios", icon: "/icons/car.png" },
  { href: "/adspacerequests", label: "Publicidad", icon: "/icons/banner-white.png" },
  { href: "/verificationrequests", label: "Verificaciones", icon: "/icons/check.png" },
  { href: "/auctionreports", label: "Reportes", icon: "/icons/pdf.png" },
];

export function AdminSidebar({ username, onLogout }) {
  return (
    <div className="column-admin">
      <p className="admin-name">Hola, {username}</p>
      <div className="admin-menu">
        {menuItems.map((item) => (
          <a href={item.href} className="element" key={item.label}>
            <img src={item.icon} alt="" className="element-img" />
            <span className="element-text">{item.label}</span>
          </a>
        ))}
        <div className="element-end" onClick={onLogout} role="button" tabIndex={0}>
          <img src="/icons/salir.png" alt="" className="element-img" />
          <p className="element-text">Salir</p>
        </div>
      </div>
    </div>
  );
}

export function AdminSidebarDropdown({ onLogout }) {
  const [isOpen, setIsOpen] = useState(false);
  const dropDownRef = useRef(null);

  const toggleDropdown = () => setIsOpen(!isOpen);

  return (
    <div ref={dropDownRef} className="whole-drop-a">
      <button onClick={toggleDropdown} id="drop-movil" className={isOpen ? "click" : ""}>
        <p className="d-text">MENU ADMINISTRADOR</p>
        {isOpen ? (
          <img src="/icons/arrow-up-dark.png" id="arrows" alt="arrow-up" />
        ) : (
          <img src="/icons/arrow-down-dark.png" id="arrows" alt="arrow-down" />
        )}
      </button>
      {isOpen && (
        <div className="drop">
          <div className="admin-menu-drop">
            {menuItems.map((item) => (
              <div className="element-d" key={item.label}>
                <img src={item.icon} alt="" className="element-img-d" />
                <a href={item.href} className="element-text-d">
                  {item.label}
                </a>
              </div>
            ))}
            <div className="element-end-d" onClick={onLogout}>
              <img src="/icons/salir.png" alt="" className="element-img-d" />
              <p className="element-text-d">Salir</p>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default AdminSidebar;
